// extracted by mini-css-extract-plugin
export default {"title-user":"MyBookPdf_title-user__3YN81"};